import { PlansType } from "@/types/PlanTypes";
import useSWR from "@/hooks/useSWR";

/**
 * The backend pages this list at 25 by default (max 100). Ask for the maximum
 * so long-lived accounts with many canceled plans still get every plan — the
 * dashboard product tabs and the nav derive product status from the full list.
 */
export function getUsePlansKey(enabled: boolean = true) {
  return {
    url: "/subscription/plan/?page_size=100",
    enabled,
  };
}

export default function usePlans(enabled: boolean = true) {
  return useSWR<PlansType>(getUsePlansKey(enabled));
}
